/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import Swal from 'sweetalert2'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useCentral} from '../../../../../../hooks/useCentral'
import {confirmModal} from '../../../../../../util/functions'
import {ClotheModel} from '../../../../model'
import {getClothesByPerson} from '../../../../services'
import {AddClothes} from '../Modal/ModalAddClothes'
const TableClothe: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, selectedOn, pagination} =
    useKTable()
  const {currentTabItem, isAllowed} = useCentral()
  const [showModalNew, setShowModalNew] = useState(false)
  const [idClothe, setIdClothe] = useState<any>('')
  const [detailClothe, setDetailClothe] = useState<ClotheModel>()

  const handleClear = () => {
    setIdClothe('')
  }
  const getClothesByPersonId = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getClothesByPerson(
        pagination.currentPage,
        pagination.perPage ?? 10,
        currentTabItem.idToEdit,
      )
      if (!response.error) {
        const newData = response.data
        setData(newData)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEdit = (item: ClotheModel) => {
    setDetailClothe(item)
    setIdClothe(item.Id)
    setShowModalNew(true)
  }

  useEffect(() => {
    getClothesByPersonId()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, currentTabItem.idToEdit])

  const columns: Column<ClotheModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].Id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Codigo de Prenda' />,
      accessor: 'CodigoPrenda',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Descripcion de Prenda' />,
      accessor: 'TipoPrenda',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'Cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'Observacion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('PRENDA/EDITAR') && (
            <div onClick={() => handleEdit(props.data[props.row.index])}>
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    let title = '¿Estás seguro?'
    let bodyText = 'Al eliminar no podrás revertir esta acción'
    let textButtonCancel = 'No'
    let textButtonConfirm = 'Si, eliminar'
    const result = await confirmModal({
      title,
      bodyText,
      icon: 'warning',
      textButtonCancel,
      textButtonConfirm,
    })
    if (!result.isConfirmed) return
    // const {data: response} = await deleteDocumentByPerson(selectedOn[0])
    // if (!response.error) {
    //   ShowSnackBar(SUCCESS_MESSAGE_DELETE)
    // } else {
    //   ShowSnackBar(response.message, 'error')
    // }
    // getDocumentByPersonList()
    Swal.close()
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      {isAllowed('PRENDA/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('PRENDA/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('PRENDA/ELIMINAR') && (
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={selectedOn.length < 1}
                onClick={handleDelete}
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns as any} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          {showModalNew ? (
            <AddClothes
              show={showModalNew}
              setShow={setShowModalNew}
              getClothesByPersonId={getClothesByPersonId}
              detailClothe={detailClothe}
              idClothe={idClothe}
              setIdClotheList={handleClear}
            />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableClotheWrapper = () => {
  return (
    <KTableProvider>
      <TableClothe />
    </KTableProvider>
  )
}
export {TableClotheWrapper}
